// extracted by mini-css-extract-plugin
export var gif = "_ij-0";